import React, {useState} from 'react';
import Button from "react-bootstrap/lib/Button";
import {getImportPapers} from "../api";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {setArePapersLoaded} from "../redux/actions";

function ImportPapersTab(props) {
    const [alert, setAlert] = useState(null);

    function onImportClick() {
        // Change alert panel when import has finished
        const onFinishCallback = ({count, url}) => {
            setAlert(
                <div className="alert alert-success"
                     role="alert">
                    <strong>{count}</strong> papers have been successfully imported from <strong>{url}</strong>
                    <br/>
                    Go to <strong><Link to="/sessions">Sessions</Link></strong> tab to see them.
                </div>);
            props.setArePapersLoaded(false);    // Force paper fetching
        };
        // Display alert
        setAlert(<div className="alert alert-info" role="alert">{"Importing..."}</div>);

        // Request backend to import papers
        getImportPapers(props.user.api_token, onFinishCallback);
    }

    return (
        <div>
            <p>To import papers, click on the following button:</p>
            <Button bsStyle="success" onClick={onImportClick}>Import</Button>
            <br/>
            <br/>
            {alert}
        </div>
    )
}

export default connect(
    null,
    {setArePapersLoaded}
)(ImportPapersTab)
